import React from 'react';
import MyNavbar from '../../../components/customer/MyNavbar';
import VenueHeadingSection from '../../../screens/customer/venues/VenueHeadingSection';
import VenueCardsSection from '../../../screens/customer/venues/VenueCardsSection';
import HotelSection from '../../../screens/customer/venues/HotelSection';
import FacilitiesSection from '../../../screens/customer/venues/FacilitiesSection';
import VenueDetailpage from '../../../screens/customer/venues/VenueDetailpage';
import Footer from '../../../components/customer/Footer';



const Venues = () => {
  return (
    <>
      <MyNavbar />
      <VenueHeadingSection />
      <VenueCardsSection />
      {/* <HotelSection /> */}
      <FacilitiesSection />
      {/* <VenueDetailpage/> */}
      <Footer />
    </>
  );
}
export default Venues;